module.exports = __webpack_public_path__ + "static/media/engine_operating.1083ae73.svg";